import { makeStyles } from '@material-ui/core/styles';
import Constants from '../../Constants';


export const useOtpStyle = makeStyles(theme => ({
    inputLabelStar: {
        '&::after': {
            // increase the specificity for the pseudo class
            content: '"*"',
            display: 'inline-block',
            color: 'red',
            textAlign: 'center',
        },
    },

    eirOtp: {
        marginBottom: '20px',
        '& .Mui-disabled': {
            // color: 'black !important',
        },
        '& .paddingClass': {
            paddingTop: '0px !important',
        },

        '& .tickright': {
            '&::after': {
                content: '""',
                display: 'inline-block',

                lineHeight: '1rem',
                position: 'absolute',
                width: '20px',
                textAlign: 'center',
                marginTop: '8px',
                marginLeft: '-27px',

                height: '20px',
                borderRadius: '100%',

                backgroundImage:
                    'url("/opencms/export/sites/default/.galleries/eir/icons/tick-icon.svg")',

                backgroundRepeat: 'no-repeat',
            },
        },

        '& .OtpPurpleButton': {
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1, 5),
            border: '1px solid #6666666b',
            background: Constants.siteTheme.primaryTheme,
            color: '#fff',
            borderColor: Constants.siteTheme.primaryTheme,
            outline: 'none',
            marginLeft: '30px',
            '@media (max-width: 1024px)': {
                marginLeft: '0px',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '&:focus,&:hover': {
                background: Constants.siteTheme.primaryTheme,
                color: '#fff',
                borderColor: Constants.siteTheme.primaryTheme,
                outline: 'none',
            },
        },
        '& .OtpValidPurpleButton': {
            marginTop: '-4px',
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1, 4),
            border: '1px solid #6666666b',
            background: Constants.siteTheme.primaryTheme,
            color: '#fff',
            borderColor: Constants.siteTheme.primaryTheme,
            outline: 'none',
            marginLeft: '18px',
            '@media (min-width: 281px) and (max-width: 1024px)': {
                marginLeft: '0px',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '@media (max-width: 280px)': {
                marginLeft: '0px',
                padding: '5px 20px',
                fontSize: 14,
            },
            '&:focus,&:hover': {
                background: Constants.siteTheme.primaryTheme,
                color: '#fff',
                borderColor: Constants.siteTheme.primaryTheme,
                outline: 'none',
            },
        },
        '& .OtpButton': {
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1, 5),
            // border: '1px solid #6666666b',
            // color: 'black !important ',
            marginLeft: '30px',
            '@media (max-width: 1024px)': {
                marginLeft: '0px',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '&:focus,&:hover': {
                background: Constants.siteTheme.primaryTheme,
                color: '#fff',
                borderColor: Constants.siteTheme.primaryTheme,
                outline: 'none',
            },
        },
        '& .OtpValidButton': {
            marginTop: '-4px',
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1, 4),
            border: '1px solid #6666666b',
            // color: 'black !important ',
            marginLeft: '18px',
            '@media ( min-width:281px) and (max-width: 1024px)': {
                marginLeft: '0px',
                padding: theme.spacing(1, 4),
                fontSize: 14,
            },
            '@media ( max-width:280px)': {
                marginLeft: '0px',
                padding: '5px 20px',
                fontSize: 14,
            },
            '&:focus,&:hover': {
                background: Constants.siteTheme.primaryTheme,
                color: '#fff',
                borderColor: Constants.siteTheme.primaryTheme,
                outline: 'none',
            },
        },
        '& .notification': {
            color: 'black',
            fontSize: '16px',
            fontFamily: ' gt-walsheim-medium',
            '@media (max-width: 1024px)': {
                fontSize: '14px',
            },
        },

        '& .retryBtn': {
            marginTop: '-4px',
            borderRadius: '2rem',
            fontSize: 15,
            textTransform: 'initial',
            fontWeight: 'bold',
            padding: theme.spacing(1, 5),
            border: '1px solid #892ba0',
            color: '#892ba0',
            background: '#fff',
            marginLeft: '15px',
            '@media (min-width: 280px) and (max-width: 1024px)': {
                marginRight: theme.spacing(1),
                padding: theme.spacing(1, 5),
                fontSize: 14,
            },
            '@media (max-width: 280px)': {
                marginRight: theme.spacing(1),

                padding: '5px 25px',
                fontSize: 14,
            },

            '&:focus': {
                background: '#fff',
                color: '#892ba0',
                border: '1px solid #892ba0',
                outline: 'none',
            },
            '&:hover': {
                background: '#fff',
                color: '#892ba0',
                border: '1px solid #892ba0',
                outline: 'none',
            },
        },
        '& .errorMessage': {
            width: '100%',
            marginTop: '.25rem',
            fontSize: 16,
            color: '#e40046',
            display: 'block',
            '@media (max-width: 767px)': {
                textAlign: 'left',
                fontSize: 14,
            },
        },
    },
}));
